import { createAnimationobject, setScrollOption, prepareSpliteText, setSize, setMultiSize } from "./fryingpanAnimationUtill";

export default class topAnimation {
  constructor(param, scroll) {
    this.param = param;
    this.scroll = scroll;

    this.is_pc = param.displayType === "pc";
    this.is_ie = this.param.browserType === 'IE'
  }

  init() {
    // animation setting
    this.setupCopy()
    this.setupLineup()
    this.setupConceptImage()
    this.setupInterviewImage()
    this.setupInterviewTitle()
    this.setupRecipebook()
    this.setupCopyLineup()
    this.setupCommonLink()
    this.setupFryingpanCopy()
    this.setupPhotowide()
    this.setupColumsImage()
    this.setupMoreLink()
  }

  onScroll(_y) {
    // single
    if (this.pCopy && !this.pCopy.isShown && _y > this.pCopy.topStart) {
      this.pCopy.isShown = true
      this.fadeInItem(this.pCopy.elm)
    }
    if (this.pCopyLineupTittle && !this.pCopyLineupTittle.isShown && _y > this.pCopyLineupTittle.topStart) {
      this.pCopyLineupTittle.isShown = true
      this.appearSplitText(this.pCopyLineupTittle)
    }
    if (this.pConceptImage && !this.pConceptImage.isShown && _y > this.pConceptImage.topStart) {
      this.pConceptImage.isShown = true
      this.fadeInItem(this.pConceptImage.elm)
    }
    if (this.pInterviewImage && !this.pInterviewImage.isShown && _y > this.pInterviewImage.topStart) {
      this.pInterviewImage.isShown = true
      this.appearInterviewImage()
    }
    if (this.pInterviewTitle && !this.pInterviewTitle.isShown && _y > this.pInterviewTitle.topStart) {
      this.pInterviewTitle.isShown = true
      this.appearInterviewTitle()
    }
    if(this.pRecipeBook && !this.pRecipeBook.isShown && _y > this.pRecipeBook.topStart) {
      this.pRecipeBook.isShown = true
      this.apperarRecipeBook(this.pRecipeBook)
    }
    // multiple
    // Linup
    if(this.pCopyLineupItem) {
      const notShownList = this.pCopyLineupItem.filter((item) => { return !item.isShown })
      notShownList.forEach((item) => {
        if (_y > item.topStart) {
          item.isShown = true
          this.appearFryingpan(item.animationElms)
        }
      })
    }
    // CommonLink
    if(this.cCommonLink) {
      const notShownList = this.cCommonLink.filter((item) => { return !item.isShown })
      notShownList.forEach((item) => {
        if (_y > item.topStart) {
          item.isShown = true
          this.fadeInItem(item.elm)
        }
      })
    }
    // CommonTitleSet
    if(this.cFryingpanCopy) {
      const notShownList = this.cFryingpanCopy.filter((item) => { return !item.isShown })
      notShownList.forEach((item) => {
        if (_y > item.topStart) {
          item.isShown = true
          this.appearTittleSet(item)
        }
      })
    }
    // CommonPhotoWide
    if(this.cPhotoWide) {
      const notShownList = this.cPhotoWide.filter((item) => { return !item.isShown })
      notShownList.forEach((item) => {
        if (_y > item.topStart) {
          item.isShown = true
          this.appearValuePropositiin(item.animationElms)
        }
      })
    }
    // CommonColumnImage
    if(this.cColumnImage) {
      const notShownList = this.cColumnImage.filter((item) => { return !item.isShown })
      notShownList.forEach((item) => {
        if (_y > item.topStart) {
          item.isShown = true
          this.revealCovers(item.animationElms)
        }
      })
    }
    // MoreInfomation
    if(this.pMoreLink) {
      const notShownList = this.pMoreLink.filter((item) => { return !item.isShown })
      notShownList.forEach((item) => {
        if (_y > item.topStart) {
          item.isShown = true
          this.apperarLink(item.animationElms)
        }
      })
    }
  }

  resize(_w, _h, _display) {
    // this.setSize(_w, _h, _display)
  }

  // setting
  setupCopy() {
    this.pCopy = {}
    setSize({ object: this.pCopy, property:'.js-p-copy-title' })
    TweenMax.set(this.pCopy.elm, { opacity: 0, rotationX: 40, y: 10 })
  }

  setupLineup() {
    this.pCopyLineupTittle = prepareSpliteText(document.querySelector('.js-p-copy-lineuptitle'), { opacity: 0, y: -15 });
    const { top, topStart } = setScrollOption(document.querySelector('.js-p-copy-lineuptitle'), 0.8)
    this.pCopyLineupTittle.top = top
    this.pCopyLineupTittle.topStart = topStart
  }

  setupConceptImage() {
    this.pConceptImage = {};
    setSize({ object: this.pConceptImage, property: '.js-p-concept-image',})
    TweenMax.set(this.pConceptImage.elm, { opacity: 0 })
    if (!this.is_ie) {
      TweenMax.set(this.pConceptImage.elm, {
        willChange: 'opacity',
      })
    }
  }

  setupInterviewImage() {
    this.pInterviewImage = {}
    setSize({ object: this.pInterviewImage, property: '.js-interview-image'})

    TweenMax.set('.js-interview-image', { opacity: 0 })
    TweenMax.set('.js-interview-image-cover', { opacity: 1})
    if (!this.is_ie) {
      TweenMax.set('.js-interview-image', {
        willChange: 'opacity',
      })
      TweenMax.set('.js-interview-image-cover', {
        willChange: 'opacity',
      })
    }
  }
  setupInterviewTitle() {
    this.pInterviewTitle = {}
    setSize({ object: this.pInterviewTitle, property: '.js-interview-titlecontent'})

    if(this.is_pc) TweenMax.set('.js-interview-titlecontent', { scaleX: 0 })
    TweenMax.set('.js-interview-vol', { opacity: 0, x: -10 })
    TweenMax.set('.js-interview-volline', { scaleX: 0 })
    TweenMax.set('.js-interview-title', { opacity: 0, y: 10 })
    TweenMax.set('.js-interview-name', { opacity: 0, y: 10 })
    TweenMax.set('.js-interview-link', { opacity: 0, y: 10 })
  }

  setupRecipebook() {
    this.pRecipeBook = {};
    setSize({ object: this.pRecipeBook, property: '.js-p-recipebook' })
    TweenMax.set(".js-p-recipebook", { opacity: 0 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook", { willChange: 'opacity' })
    }
    TweenMax.set(".js-p-recipebook-title", { opacity: 0, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook-title", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-p-recipebook-text", { opacity: 0, rotationX: 40, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook-text", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-p-recipebook-subline", { scaleX: 0, transformOrigin: 'left center' })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook-subline", { willChange: 'transform' })
    }
    TweenMax.set(".js-p-recipebook-bookphoto-26", { opacity: 0, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook-bookphoto-26", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-p-recipebook-booktext-26", { opacity: 0, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook-booktext-26", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-p-recipebook-bookphoto-24", { opacity: 0, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook-bookphoto-24", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-p-recipebook-booktext-24", { opacity: 0, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-recipebook-bookphoto-24", { willChange: 'opacity, transform' })
    }
    const { splitText, stTl } = prepareSpliteText(this.pRecipeBook.elm.querySelector('.js-p-recipebook-subtitle'), { opacity: 0, y: -15 })
    this.pRecipeBook.splitText = splitText
    this.pRecipeBook.stTl = stTl
  }

  setupCopyLineup() {
    this.pCopyLineupItem = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.js-p-copy-lineupitem'),
      (el) => {
        const obj = createAnimationobject(el, 0.8)
        obj.animationElms = {
          image: el.querySelector('.js-lineupitem-image'),
          line: el.querySelector('.js-lineupitem-line'),
          text: el.querySelector('.js-lineupitem-text')
        }

        this.pCopyLineupItem.push(obj)
      }
    )
    TweenMax.set(".js-p-copy-lineupitem .js-lineupitem-image", { opacity: 0, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-copy-lineupitem .js-lineupitem-image", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-p-copy-lineupitem .js-lineupitem-line", { scaleX: 0, transformOrigin: "center left" })
    if (!this.is_ie) {
      TweenMax.set(".js-p-copy-lineupitem .js-lineupitem-line", { willChange: 'transform' })
    }
    TweenMax.set(".js-p-copy-lineupitem .js-lineupitem-text", { opacity: 0, rotationX: 40, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-p-copy-lineupitem .js-lineupitem-text", { willChange: 'opacity, transform' })
    }
  }

  setupCommonLink() {
    this.cCommonLink = [];
    setMultiSize({ array: this.cCommonLink, property: '.js-c-linkcommon' })
    TweenMax.set(".js-c-linkcommon", { opacity: 0, rotationX: 40, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-c-linkcommon", { willChange: 'opacity, transform' })
    }
  }

  setupFryingpanCopy() {
    this.cFryingpanCopy = []
    const fcdoms = document.querySelectorAll('.js-c-fryingpancopy');
    Array.prototype.forEach.call(fcdoms, (dom) => {
      const object = { isShown: false }
      object.elm = dom
      const { top, topStart } = setScrollOption(object.elm, 0.8)
      object.top = top
      object.topStart = topStart

      const { splitText, stTl } = prepareSpliteText(object.elm.querySelector('.js-c-fryingpancopy-en'), { opacity: 0, y: 10 })
      object.animationelm = {
        en : splitText,
        jp : object.elm.querySelector('.js-c-fryingpancopy-jp'),
        detailtext : object.elm.querySelector('.js-c-fryingpancopy-detailtext') ? object.elm.querySelector('.js-c-fryingpancopy-detailtext') : null,
        detailtitle : object.elm.querySelector('.js-c-fryingpancopy-detailtitle') ? object.elm.querySelector('.js-c-fryingpancopy-detailtitle') : null
      }
      object.tl = stTl
      object.tl.set(object.animationelm.jp, { opacity: 0, y: 10 })
      if(object.animationelm.detailtext) object.tl.set(object.animationelm.detailtext, { opacity: 0, rotationX: 40, y: 10 })
      if(object.animationelm.detailtitle) object.tl.set(object.animationelm.detailtitle, { opacity: 0, y: 10 })

      this.cFryingpanCopy.push(object)
    })
  }

  setupPhotowide() {
    this.cPhotoWide = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.js-c-photowide'),
      (el) => {
        const obj = createAnimationobject(el, 0.8)
        obj.animationElms = {
          photo: el.querySelector('.js-c-photowide-photo'),
          copy: el.querySelector('.js-c-photowide-copy'),
          text: el.querySelector('.js-c-photowide-text')
        }

        this.cPhotoWide.push(obj)
      }
    )
    TweenMax.set(".js-c-photowide-photo", { opacity: 0, scale: 1.015 })
    if (!this.is_ie) {
      TweenMax.set(".js-c-photowide-photo", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-c-photowide-copy", { opacity: 0 })
    if (!this.is_ie) {
      TweenMax.set(".js-c-photowide-copy", { willChange: 'opacity' })
    }
    TweenMax.set(".js-c-photowide-text", { opacity: 0, rotationX: 10, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-c-photowide-text", { willChange: 'opacity, transform' })
    }
  }

  setupColumsImage() {
    this.cColumnImage = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.js-c-columnimage'),
      (el) => {
        const obj = createAnimationobject(el, 0.8)
        obj.animationElms = {
          gradient: el.querySelector('.js-c-columnimage-gradient'),
          cover: el.querySelector('.js-c-columnimage-cover')
        }

        this.cColumnImage.push(obj)
      }
    )
    TweenMax.set(".js-c-columnimage-gradient", { opacity: 1 })
    if (!this.is_ie) {
      TweenMax.set(".js-c-columnimage-gradient", { willChange: 'opacity' })
    }
    TweenMax.set(".js-c-columnimage-cover", { opacity: 1 })
    if (!this.is_ie) {
      TweenMax.set(".js-c-columnimage-cover", { willChange: 'opacity' })
    }
  }

  setupMoreLink() {
    this.pMoreLink = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.js-moreinformation'),
      (el) => {
        const obj = createAnimationobject(el, 0.8)
        obj.animationElms = {
          elm: el,
          icon: el.querySelector('.js-moreinformation-icon'),
          en: el.querySelector('.js-moreinformation-en'),
          jp: el.querySelector('.js-moreinformation-jp')
        }

        this.pMoreLink.push(obj)
      }
    )
    // setting
    TweenMax.set(".js-moreinformation", { opacity: 0 })
    if (!this.is_ie) {
      TweenMax.set(".js-moreinformation", { willChange: 'opacity' })
    }
    TweenMax.set(".js-moreinformation-icon", { opacity: 0, rotationX: 40, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-moreinformation-icon", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-moreinformation-en", { opacity: 0, rotationX: 40, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-moreinformation-en", { willChange: 'opacity, transform' })
    }
    TweenMax.set(".js-moreinformation-jp", { opacity: 0, rotationX: 40, y: 10 })
    if (!this.is_ie) {
      TweenMax.set(".js-moreinformation-jp", { willChange: 'opacity, transform' })
    }
  }

  // animationm
  fadeInItem(elm) {
    TweenMax.to(elm, 0.6, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeIn })
  }

  fadeInRight(elm) {
    TweenMax.to(elm, 0.6, { opacity: 1, x: 0, ease: Sine.easeIn })
  }

  appearSplitText(object) {
    for(var i = 0; i < object.splitText.chars.length ; i++){
      object.stTl.staggerTo(object.splitText.chars, 0.15, { opacity: 1, y: 0, ease: Back.easeOut.config(2.4) }, 0.04)
    }
  }

  appearFryingpan(elms) {
    const afTl = new TimelineMax()
    afTl
      .to(elms.image, 0.7, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeIn }, 0)
      .to(elms.line, 0.6, { scaleX: 1, ease: Sine.easeIn }, "-=0.3")
      .to(elms.text, 0.4, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeIn }, "-=0.3")
  }

  appearTittleSet(object) {
    object.tl.staggerTo(object.animationelm.en.chars, 0.15, { opacity: 1, y: 0, ease: Back.easeOut.config(2.4) }, 0.04)
    object.tl.to(object.animationelm.jp, 0.7, { opacity: 1, y: 0, ease: Power3.easeOut }, "-=0.2")

    if(object.animationelm.detailtext) object.tl.to(object.animationelm.detailtext, 0.5, { opacity: 1, rotationX: 0, y: 0, ease: Power3.easeOut }, "-=0.5")
    if(object.animationelm.detailtitle) object.tl.to(object.animationelm.detailtitle, 1.2, { opacity: 1, y: 0, ease: Power3.easeOut }, "-=0.8")
  }

  appearValuePropositiin(elms) {
    const afTl = new TimelineMax()
    afTl
      .to(elms.photo, 0.8, { opacity: 1, scale: 1.0, ease: Sine.easeIn }, 0)
      .to(elms.copy, 0.5, { opacity: 1, ease: Power3.easeIn }, "-=0.4")
      .to(elms.text, 0.5, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeIn }, "-=0.4")
  }

  appearInterviewImage(obj) {
    TweenMax.set('.js-interview-image', { opacity: 0 })
    TweenMax.set('.js-interview-image-cover', { opacity: 1})
    const aiiTl = new TimelineMax()
    aiiTl
      .to('.js-interview-image', 0.5, { opacity: 1, ease: Sine.easeIn }, 0)
      .to('.js-interview-image-cover', 0.8,{ opacity: 0, ease: Sine.easeIn }, 0)

  }

  appearInterviewTitle(obj) {
    TweenMax.set('.js-interview-volline', { scaleX: 0 })
    const aitTl = new TimelineMax()
    if(this.is_pc) aitTl.to('.js-interview-titlecontent', 0.6, { scaleX: 1, ease: Sine.easeOut }, 0)

    aitTl
      .to('.js-interview-vol', 0.4, { opacity: 1, x: 0, ease: Sine.easeOut}, "-=0.1")
      .to('.js-interview-volline', 0.4, { scaleX: 1, ease: Sine.easeOut }, "-=0.2")
      .to('.js-interview-title', 0.3, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.2")
      .to('.js-interview-name', 0.3, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.2")
      .to('.js-interview-link', 0.3, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.2")
  }

  revealCovers(elms) {
    const rcTl = new TimelineMax()
    rcTl
      .to(elms.cover, 0.6, { opacity: 0, ease: Sine.easeIn }, 0)
      .to(elms.gradient, 0.8, { opacity: 0, ease: Sine.easeOut }, 0)
  }

  apperarRecipeBook(object) {
    object.stTl.to('.js-p-recipebook', 0.5, {opacity: 1, ease: Sine.easeOut }, 0)
    object.stTl.staggerTo(object.splitText.chars, 0.1, { opacity: 1, y: 0, ease: Back.easeOut.config(2.1) }, 0.03)
    object.stTl
      .to('.js-p-recipebook-subline', 0.5, { scaleX: 1, ease: Sine.easeOut }, "-=0.1")
      .to('.js-p-recipebook-bookphoto-24', 0.5, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.6")
      .to('.js-p-recipebook-bookphoto-26', 0.5, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.6")
      .to('.js-p-recipebook-booktext-24', 0.5, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.6")
      .to('.js-p-recipebook-booktext-26', 0.5, { opacity: 1, y: 0, ease: Sine.easeOut }, "-=0.6")
      .to('.js-p-recipebook-title', 0.5, { opacity: 1, x: 0, ease: Sine.easeOut }, "-=0.8")
      .to('.js-p-recipebook-text', 0.5, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeOut }, "-=0.7")
  }

  apperarLink(elms) {
    const alTl = new TimelineMax()
    alTl
      .to(elms.elm, 0.6, { opacity: 1, ease: Sine.easeIn }, 0)
      .to(elms.icon, 0.6, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeIn }, "-=0.4")
      .to(elms.en, 0.6, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeOut }, "-=0.4")
      .to(elms.jp, 0.6, { opacity: 1, rotationX: 0, y: 0, ease: Sine.easeOut }, "-=0.4")
  }
}